{
  "INDIVIDUAL": "Individual",
  "PUBLICLY_LISTED_ENTITY": "Entidad que cotiza en bolsa",
  "PRIVATE_COMPANY": "Empresa privada",
  "PARTNERSHIP": "Asociación",
  "SOLE_PROPRIETORSHIP": "Empresa unipersonal",
  "TRUST": "Fideicomiso",
  "INVESTMENT_FUND": "Fondo de inversión",
  "REGULATED_ENTITY": "Entidad regulada",
  "OTHER": "Otros",
  "NON_INDIVIDUAL": "No individual"
}
